import * as React from "react";
import { Flex, MenuButton, Spacer, Text } from "@chakra-ui/react";
import { IoShareOutline } from "react-icons/io5";
import { MdArrowForwardIos } from "react-icons/md";
import { Export } from "components";
import { SelectionContext } from "../../../../../../duck";

interface ExportCaseProps {
  isVetspireCase: boolean;
  onClose(): void;
}

const ExportCase: React.FC<ExportCaseProps> = ({ isVetspireCase, onClose }) => {
  const { selection, reset } = React.useContext(SelectionContext);

  return (
    <Export
      caseId={selection[0]._id}
      isVetspireCase={isVetspireCase}
      menuButton={
        <MenuButton
          _hover={{ background: "gray.100" }}
          _active={{ background: "gray.200" }}
          w="100%"
          p="6px 12px"
          color="gray.900"
          fontSize="sm"
        >
          <Flex align="center" columnGap="12px">
            <IoShareOutline size="12px" />
            <Text>Export</Text>
            <Spacer />
            <MdArrowForwardIos size="12px" />
          </Flex>
        </MenuButton>
      }
      onClose={() => {
        reset();
        onClose();
      }}
    />
  );
};

export default ExportCase;
